import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=3000d247&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "./Paper.vue?vue&type=style&index=0&id=3000d247&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3000d247",
  null
  
)

export default component.exports